export const getCountLines = (paragraph: HTMLElement) => {
    const styles = window.getComputedStyle(paragraph);
    const lineHeight = parseFloat(styles.lineHeight); // Получаем высоту одной строки
    const paragraphHeight = paragraph.offsetHeight; // Высота всего параграфа

    return Math.round(paragraphHeight / lineHeight); // Количество строк
};
